"use client";

import { createContext, type ReactNode, useCallback, useContext } from "react";

export type AssetImageResolver = (src: string) => string;
const AssetImageContext = createContext<AssetImageResolver>((src) => src);

/** Resolve trusted host assets without changing portable component props. */
export function AssetImageProvider({
  resolve,
  children,
  inherit = false,
}: {
  resolve: AssetImageResolver;
  children: ReactNode;
  inherit?: boolean;
}) {
  const parent = useContext(AssetImageContext);
  const composed = useCallback((src: string) => resolve(parent(src)), [parent, resolve]);
  return <AssetImageContext.Provider value={inherit ? composed : resolve}>{children}</AssetImageContext.Provider>;
}

export function useAssetImage(src: string | undefined): string | undefined {
  const resolve = useContext(AssetImageContext);
  return src === undefined ? undefined : resolve(src);
}
